import {ApiDataParser} from "../parser/ApiParser";

export class Api {
    constructor(apiBaseUrl) {
        this.baseUrl = apiBaseUrl;
        this.options = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
            },
            method: "POST",
        };
        this.error = {};
    };

    async request(url, data) {
        try {
            const apiData = new ApiDataParser(data);
            this.options.body = apiData.parse();
            let response = await fetch(this.baseUrl + url, this.options);
            let json = await response.json();
            if(json.resultType === "VALIDATION_FAILED") {
                let err = Object.assign(json);
                err.message = "";
                for(var i in err.presentation) {
                    if(err.presentation[i].controlState === "ERROR") {
                        err.message += err.presentation[i].name + ": " + err.presentation[i].message + "; ";
                    }
                }
                throw new Error(JSON.stringify(err));
            }
            if(json.resultType !== "SUCCESS") {
                throw new Error(JSON.stringify(json));
            }
            return json;
        } catch(err) {
            let error = JSON.parse(err.message);
            error = Object.assign(error);
            error.resultType = error.resultType || "ERROR";
            error.message = error.message || "Connection Error";
            throw new Error(JSON.stringify(error));
        }
    };
}


// WEBPACK FOOTER //
// ./src/utils/Api.js